module.exports = __webpack_public_path__ + "b586ef696d05d86f3134d2dbb1533672.svg";